import { Injectable } from '@angular/core'
import * as _ from 'lodash'
import { BehaviorSubject, Observable } from 'rxjs'

import { SnackBarOptions } from './progress-indicator.service'

class AsyncProcess {
  id: number
  inProgress = false

  constructor(private progressService: MockProgressIndicatorService) {
    this.id = Date.now()
  }

  start(): AsyncProcess {
    this.inProgress = true
    this.progressService.start(this)
    return this
  }

  stop(snackBarOptions?: string | SnackBarOptions): AsyncProcess {
    this.inProgress = false
    this.progressService.stop(this)

    if (snackBarOptions) {
      // this.progressService.snack(snackBarOptions)
    }

    return this
  }
}

@Injectable()
export class MockProgressIndicatorService {
  public enabled: Observable<boolean>
  private subject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  )
  private _enabled = false
  private requests: AsyncProcess[] = []

  constructor() {
    this.enabled = this.subject.asObservable()
  }

  async(): AsyncProcess {
    return new AsyncProcess(this)
  }

  start(process?: AsyncProcess): AsyncProcess {
    if (_.isNil(process)) {
      process = this.async()
    }

    this.requests.push(process)

    if (!this._enabled) {
      this.subject.next(true)
      this._enabled = true
    }

    return process
  }

  stop(process: AsyncProcess): AsyncProcess {
    this.requests = _.without(this.requests, process)

    if (this.requests.length === 0) {
      this.subject.next(false)
      this._enabled = false
    }

    return process
  }

  // snack(snackBarOptions: SnackBarOptions | string) {
  //   if (_.isString(snackBarOptions)) {
  //     snackBarOptions = {
  //       message: snackBarOptions,
  //     }
  //   }
  //
  //   return { }
  // }
}
